import angular from 'angular';

import StopPropagationDirective, { selector } from './stop-propagation.directive';

export default angular.module('common.directive.stop-propagation', [])
    .directive(selector, StopPropagationDirective);



// WEBPACK FOOTER //
// ./src/common/directive/stop-propagation/index.js